import { Action, createReducer, on } from '@ngrx/store';

import {
  CognitoAuthState,
  initialCognitoAuthState
} from './cognito-auth.state';
import * as CognitoAuthActions from './cognito-auth.actions';

const cognitoAuthReducer = createReducer<CognitoAuthState>(
  initialCognitoAuthState,

  on(CognitoAuthActions.signinWithGoogle, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(CognitoAuthActions.signInWithGoogleInProgress, (state) => ({
    ...state,
    isLoading: false,
    error: null,
    isInProgress: true
  })),

  on(CognitoAuthActions.signinWithGoogleFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
    isInProgress: false
  })),

  on(CognitoAuthActions.signinWithLinkedIn, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(CognitoAuthActions.signInWithLinkedInInProgress, (state) => ({
    ...state,
    isLoading: false,
    error: null,
    isInProgress: true
  })),

  on(CognitoAuthActions.signinWithLinkedInFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
    isInProgress: false
  })),

  on(CognitoAuthActions.signInWithMagicLink, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(CognitoAuthActions.signInWithMagicLinkSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),

  on(CognitoAuthActions.signInWithMagicLinkFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),

  on(CognitoAuthActions.signOutInProgress, (state) => ({
    ...state,
    username: null,
    userId: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    isInProgress: true
  })),

  on(CognitoAuthActions.signOut, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(CognitoAuthActions.signOutFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),

  on(
    CognitoAuthActions.checkAuthenticationStatusSuccess,
    (state, { isAuthenticated, user }) => ({
      ...state,
      isAuthenticated,
      username: user?.username || null,
      userId: user?.userId || null,
      isLoading: false,
      error: null,
      isInProgress: false
    })
  ),

  on(
    CognitoAuthActions.checkAuthenticationStatusFailure,
    (state, { error }) => ({
      ...state,
      isAuthenticated: false,
      username: null,
      userId: null,
      isLoading: false,
      error: error,
      isInProgress: false
    })
  ),

  on(CognitoAuthActions.confirmSignInWithMagicLink, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(CognitoAuthActions.confirmSignInWithMagicLinkSuccess, (state) => ({
    ...state,
    isAuthenticated: true,
    isLoading: false,
    error: null
  })),

  on(
    CognitoAuthActions.confirmSignInWithMagicLinkFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error: error
    })
  ),

  on(CognitoAuthActions.cognitoCallback, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(CognitoAuthActions.cognitoCallbackSuccess, (state, { token }) => ({
    ...state,
    isLoading: false,
    error: null
  })),

  on(CognitoAuthActions.cognitoCallbackFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  }))
);

export function reducer(state: CognitoAuthState | undefined, action: Action) {
  return cognitoAuthReducer(state, action);
}
